import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Boton from '../components/form/boton';
import Escala from '../components/form/escala';
import TextArea from '../components/form/textarea';
import image from '../assets/img/image-default.png';
import gracias from '../assets/img/great.png';
import preguntasData from '../data/preguntas.json';
import AuthContext from '../context/AuthContext';

const Cuestionario = () => {

    const { logout } = useContext(AuthContext);
    const navigate = useNavigate();

    /**Estados formulario*/
    const [error, setError] = useState('');
    const [enviando, setEnviando] = useState(false);
    const [enviado, setEnviado] = useState(false);

    /**Estado preguntas */
    const [respuestas, setRespuestas] = useState({});

    /**Estados de contenido */
    const [escudoUrl, setEscudoUrl] = useState(null);
    const [club, setClub] = useState(null);
    const [codClub, setCodClub] = useState(null);
    const [delegacion, setDelegacion] = useState(null);

    // Actualiza el estado de las respuestas según la pregunta y su valor
    const handleRespuestaChange = (preguntaId, respuesta) => {
        setRespuestas((prevRespuestas) => ({
            ...prevRespuestas,
            [preguntaId]: respuesta,
        }));
    };

    // Filtramos las preguntas por apartado
    const preguntasPorApartado = {
        fcf: preguntasData.filter(item => item.apartado === "fcf"),
        delegacion: preguntasData.filter(item => item.apartado === "delegacion"),
        suggeriments: preguntasData.filter(item => item.apartado === "suggeriments"),
        altres: preguntasData.filter(item => item.apartado === "altres"),
    };

    const handleSubmit = async (e) => {

        e.preventDefault();    

        setEnviando(true);

        // Verifica si todas las preguntas tipo "escala" tienen respuesta
        const preguntasEscala = preguntasData.filter(item => item.tipo === 'escala');
        const respuestasIncompletas = preguntasEscala.filter(pregunta => !respuestas[pregunta.id]);

        if (respuestasIncompletas.length > 0) {
            setError("S'ha de respondre totes les preguntes de tipus numeric per poder enviar el formulari.");
            setEnviando(false); 
            return;
        }

        // Si todas las respuestas están presentes
        setError('');

        //Creamos el objeto para enviarlo a la API
        var payload = {
            codclub: codClub,
            nombre: club,
            delegacion: delegacion,
            preg1: respuestas[1] || '',
            preg2: respuestas[2] || '',
            preg3: respuestas[3] || '',
            preg4: respuestas[4] || '',
            preg5: respuestas[5] || '',
            preg6: respuestas[6] || '',
            preg7: respuestas[7] || ''
        }

        try {
            const response = await fetch('https://dev-backend.fcf.services/forms/encuestaclubs/encuesta', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
    
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
    
            const data = await response.json();
            if (data.success) {
                setEnviado(true);
            } else {
                throw new Error("API response indicates failure");
            }
        } catch (error) {
            console.error("Error fetching: ", error);
        } finally {
            setEnviando(false);
        }
    };

    useEffect(() => {
        if (enviado) {

            // Scroll hasta la parte superior
            window.scrollTo({ top: 0, behavior: 'smooth' });
            
            const timer = setTimeout(() => {
                logout(); // Cierra la sesión
                navigate('/'); // Redirige al inicio de sesión
            }, 5000); // 10 segundos

            return () => clearTimeout(timer); // Limpia el temporizador en caso de que el componente se desmonte
        }
    }, [enviado, logout, navigate]);

    useEffect(() => {
        // Oculta el error si las respuestas cambian
        setError('');
    }, [respuestas]);

    /**Datos de usuario que ha inicado sesión */
    useEffect(() => {
        // Obtener el usuario del localStorage
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            const userData = JSON.parse(storedUser);
            // Establecer la URL del escudo
            setEscudoUrl(userData.escudo);
            setClub(userData.nombre);
            setCodClub(userData.codigo);
            setDelegacion(userData.delegacion);
        }
    }, []);

    console.log(enviado);

    return (
        <React.Fragment>
             <div id= "contenedor" className='w-full mx-auto bg-white flex justify-center md:p-12 sm:h-screen md:h-auto'>
                <div id="tarjeta" className="p-5 md:p-12 sm:w-full sm:h-full md:h-auto md:w-2/3 max-w-full mx-auto mt-0 mb-0 rounded bg-background shadow-md font-inter flex flex-col justify-between">
                {
                        enviado 
                        ? 
                        (
                            <div className={`w-full ${enviado ? 'h-screen md:h-auto' : 'h-auto'} flex flex-col items-center`}>
                                <img src={gracias} alt="gracies" width={150}/>
                                <p className='text-2xl font-bold mt-10'>Gràcies per participar donant la teva opinió.</p>
                            </div>
                        ) 
                        :
                        (
                            <div className='w-full'>                              
                                <div className='mt-4 flex flex-row items-start'>
                                    <img src={escudoUrl ? escudoUrl : image} alt="Escudo club" width={50}/>
                                    <div className='space-y-2 mb-4 ml-2'>
                                        <p className='sm:text-sm md:text-md font-semibold'>{codClub + " - "+ club}</p>
                                        <p className='sm:text-sm md:text-md font-semibold'>{delegacion}</p>
                                    </div>
                                </div>
                                <form onSubmit={handleSubmit} noValidate className='flex flex-col w-full space-y-8'>
                                    {/*Sección FCF*/}
                                    {
                                        preguntasPorApartado.fcf.length > 0 && (
                                            <div id="fcf" className='mt-10'>
                                            <h2 className='font-bold text-2xl'>Federació Catalana de Futbol</h2>
                                            <p className='text-sm mb-3 pb-1 border-b-2 border-customRed'>Respon les següents preguntes segons si creus que es molt baixa (1) o molt alta (10).</p>
                                            {preguntasPorApartado.fcf.map((item, index) => (
                                                <div key={`pregunta-${index}`} className='space-y-3 mt-8'>
                                                    <p className='font-bold'>{item.pregunta}</p>
                                                    {item.tipo === "escala" ? (
                                                        <Escala
                                                            preguntaId={item.id}
                                                            onChange={handleRespuestaChange}
                                                            respuestaSeleccionada={respuestas[item.id]}
                                                        />
                                                    ) : (
                                                        <TextArea
                                                            preguntaId={item.id}
                                                            onChange={handleRespuestaChange}
                                                            respuestaSeleccionada={respuestas[item.id]}
                                                        />
                                                    )}
                                                </div>
                                            ))}
                                            </div>
                                        )
                                    }
                                    {/**Sección Delegación */}
                                    {
                                        preguntasPorApartado.delegacion.length > 0 && (
                                            <div id="delegacion" className='mt-10'>
                                            <h2 className='font-bold text-2xl'>Delegació</h2>
                                            <p className='text-sm mb-3 pb-1 border-b-2 border-customRed'>Respon les següents preguntes segons si creus que es molt baixa (1) o molt alta (10).</p>
                                            {preguntasPorApartado.delegacion.map((item, index) => (
                                                <div key={`pregunta-${index}`} className='space-y-3 mt-8'>
                                                    <p className='font-bold'>{item.pregunta}</p>
                                                    {item.tipo === "escala" ? (
                                                        <Escala
                                                            preguntaId={item.id}
                                                            onChange={handleRespuestaChange}
                                                            respuestaSeleccionada={respuestas[item.id]}
                                                        />
                                                    ) : (
                                                        <TextArea
                                                            preguntaId={item.id}
                                                            onChange={handleRespuestaChange}
                                                            respuestaSeleccionada={respuestas[item.id]}
                                                        />
                                                    )}
                                                </div>
                                            ))}
                                            </div>
                                        )
                                    }
                                    {/**Sección sugerimentos */}
                                    {
                                        preguntasPorApartado.suggeriments.length > 0 && (
                                            <div id="suggeriments" className='mt-10'>
                                            <h2 className='font-bold text-2xl'>Suggeriments</h2>
                                            <p className='text-sm mb-3 pb-1 border-b-2 border-customRed'>Respon les següents preguntes omplint els quadres de text.</p>
                                            {preguntasPorApartado.suggeriments.map((item, index) => (
                                                <div key={`pregunta-${index}`} className='space-y-3 mt-8'>
                                                    <p className='font-bold'>{item.pregunta}</p>
                                                    {item.tipo === "escala" ? (
                                                        <Escala
                                                            preguntaId={item.id}
                                                            onChange={handleRespuestaChange}
                                                            respuestaSeleccionada={respuestas[item.id]}
                                                        />
                                                    ) : (
                                                        <TextArea
                                                            preguntaId={item.id}
                                                            onChange={handleRespuestaChange}
                                                            respuestaSeleccionada={respuestas[item.id]}
                                                        />
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                        )
                                    }
                                    {
                                        preguntasPorApartado.altres.length > 0 && (
                                            <div id="altres" className='mt-20'>
                                                <h2 className='font-bold text-2xl'>Altres</h2>
                                                <p className='text-sm mb-3 pb-1 border-b-2 border-customRed'>Comenta el que consideris oportú i que no hagi sigut abordat per qüestions anteriors</p>
                                                {preguntasPorApartado.altres.map((item, index) => (
                                                <div key={`pregunta-${index}`} className='space-y-3 mt-8'>
                                                    {item.tipo === "escala" ? (
                                                        <Escala
                                                            preguntaId={item.id}
                                                            onChange={handleRespuestaChange}
                                                            respuestaSeleccionada={respuestas[item.id]}
                                                        />
                                                    ) : (
                                                        <TextArea
                                                            preguntaId={item.id}
                                                            onChange={handleRespuestaChange}
                                                            respuestaSeleccionada={respuestas[item.id]}
                                                        />
                                                    )}
                                                </div>
                                            ))}
                                            </div>
                                        )
                                    }
                                    { error && <p className='text-red-500 text-sm'>{error}</p>}
                                    <div className='sm:w-full md:w-1/4'>
                                        <Boton texto={enviando ? "Enviant..." : "Enviar"} disabled={enviando}/>
                                    </div>
                                    
                                    
                                </form>  
                            </div>
                    )                      
                }
                
                </div>
            </div>
        </React.Fragment>
    );
}

export default Cuestionario;